import globalMessage from "@/utils/globalMessage";
import React, {PureComponent} from 'react';
import { Col, Row, Spin, Modal } from "antd";
import BarChart from "@containers/facility/Benchmark/Chart/BarChart";
import GoogleMaps from "@components/GoogleMaps";
import {colors} from "@containers/facility/Benchmark/Chart/colors";
import _ from "lodash";
import actions from "@redux/facilitybenchmark/actions";
import EditableTableActions from "@redux/EditableTable/actions";
import {connect} from "react-redux";
import moment from "moment";
import {api} from "@redux/api";


import {
    FacilityBenchmarkColumns,
    FacilityBenchmarkProps
} from "@/containers/facility/Benchmark/FacilityBenchmarkInner/FacilityBenchmarkColumns";
import {FacilityBenchmarkStyles} from "@/containers/facility/Benchmark/FacilityBenchmarkInner/FacilityBenchmarkStyle";
import dashboard from "@assets/icons/bar-chart.png";
import {asOfDate, removeDuplicates} from "@components/help";
import {jsforceResponse} from "@config/httpService";

import FacilityBenchmarkTableContent
    from "@containers/facility/Benchmark/FacilityBenchmarkTable/FacilityBenchmarkTableContent";
import {FacilityBenchmarkFilters,} from "@/containers/facility/Benchmark/FacilityBenchmarkInner/FacilityBenchmarkFilters";
import BubblePlot from "@containers/facility/Benchmark/Chart/BubblePlot";
import ResponsiveModal from "@components/ResponsiveModal";

class FacilityBenchmark extends PureComponent {

    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            data: [],
            allFilteredData: [],
            rawData: [], // 存储原始数据（未过滤），用于生成筛选器选项
            filter_dates: [],
            selected_months: [],
            selected_id: [],
            chart1_data: [],
            chart2_data: [],
            chart3_data: [],
            chart4_data: [],
            colors_type: null,

            filters: [],
            filtered_start_year: null,
            filtered_end_year: null,
            filtered_category: [],
            filtered_region: [],
            filtered_city: [],
            filtered_state: [],
            filtered_country: [],
            filtered_climate_zone: [],
            filtered_company: [],
            visible: false,
            isLoading: false,
            end_max_year: null,
            start_min_year: null,
            facilityCategoryOptions: [], // 添加设施类别枚举选项
            category_options: [] // 添加类别选项
        }
    }

    async componentDidMount() {
        // 加载设施类别枚举
        try {
            const response = await api.getFacilityCategory();
            if (response.status === 200) {
                // 现在接口不再分页，直接返回数组
                const categories = Array.isArray(response.data) ? response.data : (response.data?.results || []);
                // 转换为 Select 组件需要的格式
                // value 使用 ID，label 使用名称
                const categoryOptions = categories.map(item => ({
                    label: item.name || item.category_name,
                    value: item.id
                }));
                this.setState({
                    facilityCategoryOptions: categories,
                    category_options: categoryOptions
                });
            }
        } catch (error) {
            console.error('Failed to load facility categories:', error);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {

    }

    handleCreate = () => {

    }

    handleDeleteBenchmark = (benchmarkId) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this benchmark?',
            content: 'This action cannot be undone.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const response = await api.deleteBenchmark(benchmarkId);
                    
                    if (response.status === 204 || response.status === 200) {
                        globalMessage.success({
                            message: 'Success',
                            description: 'Benchmark deleted successfully',
                        });
                        // 清空缓存的原始数据，强制重新从服务器获取
                        this.setState({ rawData: [] }, () => {
                            // 刷新表格，会触发 handleFilter 重新获取数据
                            this.refresh(true);
                        });
                    } else {
                        globalMessage.error({
                            message: 'Error',
                            description: 'Failed to delete benchmark',
                        });
                    }
                } catch (error) {
                    console.error('Error deleting benchmark:', error);
                    globalMessage.error({
                        message: 'Error',
                        description: 'Failed to delete benchmark',
                    });
                }
            },
        });
    }

    handleBulkInsert = (body) => {

    }

    handleBulkDelete = (body) => {

    }

    handOnlineSave = (key, row) => {
        return api.editFacilityBenchmark(key, row).then(
            response => {

                return response
            }
        ).catch(error => (
            error
        ));
    }

    // 前端筛选方法
    applyClientSideFilters = (data) => {
        let filteredData = data;

        // 年份范围筛选
        if (this.state.filtered_start_year) {
            filteredData = filteredData.filter(item => 
                item.year && parseInt(item.year) >= parseInt(this.state.filtered_start_year)
            );
        }
        if (this.state.filtered_end_year) {
            filteredData = filteredData.filter(item => 
                item.year && parseInt(item.year) <= parseInt(this.state.filtered_end_year)
            );
        }

        // 地区筛选
        if (this.state.filtered_region && this.state.filtered_region.length > 0) {
            filteredData = filteredData.filter(item => 
                this.state.filtered_region.includes(item.region)
            );
        }

        // 城市筛选
        if (this.state.filtered_city && this.state.filtered_city.length > 0) {
            filteredData = filteredData.filter(item => 
                this.state.filtered_city.includes(item.city)
            );
        }

        // 州/省筛选
        if (this.state.filtered_state && this.state.filtered_state.length > 0) {
            filteredData = filteredData.filter(item => 
                this.state.filtered_state.includes(item.state)
            );
        }

        // 国家筛选
        if (this.state.filtered_country && this.state.filtered_country.length > 0) {
            filteredData = filteredData.filter(item => 
                this.state.filtered_country.includes(item.country)
            );
        }

        // 类别筛选（使用 facility_category 字段）
        if (this.state.filtered_category && this.state.filtered_category.length > 0) {
            filteredData = filteredData.filter(item => 
                this.state.filtered_category.includes(item.facility_category)
            );
        }

        // 气候区筛选
        if (this.state.filtered_climate_zone && this.state.filtered_climate_zone.length > 0) {
            filteredData = filteredData.filter(item => 
                this.state.filtered_climate_zone.includes(item.climate_zone)
            );
        }

        return filteredData;
    }


    handleFilter = async (query) => {

        this.setState({
            isLoading: true
        })

        // 从 query string 中解析分页参数
        const params = new URLSearchParams(query);
        const page = parseInt(params.get('page')) || 1;
        const pageSize = parseInt(params.get('page_size')) || 24;

        let result;

        // 首次加载时，获取所有数据并缓存
        if (this.state.rawData.length === 0) {
            let allDataQuery = 'company=' + this.props.CurrentCompany;
            let allDataResult = await api.getInternalFacilityBenchmark(allDataQuery);
            allDataResult = jsforceResponse(allDataResult);
            allDataResult = _.get(allDataResult, 'data.results') || [];
            allDataResult = allDataResult.filter(item => item.company_id === this.props.CurrentCompany);

            this.setState({ rawData: allDataResult });
            // 立即生成筛选器选项（基于原始数据）
            this.generateFilterOptions(allDataResult);
            result = allDataResult;
        } else {
            // 后续筛选直接使用缓存的原始数据，避免重复请求后端
            result = this.state.rawData;
        }

        // 应用所有前端筛选
        let all_facilities = this.applyClientSideFilters(result);
        const totalCount = all_facilities.length;

        // 分页：手动切片
        const paginatedData = all_facilities.slice((page - 1) * pageSize, page * pageSize);
        let chart1_data = [], chart2_data = [], chart3_data = [], colors_type = [];
        let isCurrentIndex = 0, isCurrentId = 0;

        for (let i = 0; i < all_facilities.length; i++) {

            if (all_facilities[i]['facility_id'] === this.props.CurrentFacility) {
                isCurrentId = all_facilities[i]['id'];
                all_facilities[i]['isCurrent'] = true
            }

            colors_type[all_facilities[i]['facility_category_name']] = colors[i]

            const year = all_facilities[i]['year'] ? + all_facilities[i]['year'] + '' : '';
            const eui = all_facilities[i]['eui'] ? + all_facilities[i]['eui'] : '';
            const energy_costs_sqft = all_facilities[i]['energy_costs_sqft'] ? + all_facilities[i]['energy_costs_sqft'] : '';
            const size = all_facilities[i]['size'] ? + all_facilities[i]['size'] : '';
            const category = all_facilities[i]['facility_category_name'] ? all_facilities[i]['facility_category_name'] : '';
            const isCurrent = all_facilities[i]['facility_id'] === this.props.CurrentFacility;
            const facilityName = all_facilities[i]['facility'] ? all_facilities[i]['facility'] : '';
            // for mock
            // const isCurrent = all_facilities[i]['facility_id'] === this.props.CurrentFacility || all_facilities[i]['id'] < 60;

            if(year && eui && size) {
                chart1_data.push({
                    facilityName,
                    key: i,
                    xAxis: year,
                    yAxis: eui,
                    size,
                    type: category,
                    isCurrent,
                })
            }

            if(year && energy_costs_sqft && size) {
                chart2_data.push({
                    facilityName,
                    key: i,
                    xAxis: year,
                    yAxis: energy_costs_sqft,
                    size,
                    type: category,
                    isCurrent,
                })
            }
            // chart2_data.push({
            //     key: i,
            //     xAxis: all_facilities[i]['year'],
            //     yAxis: all_facilities[i]['energy_costs_sqft'],
            //     size: parseInt(all_facilities[i]['size']),
            //     type: all_facilities[i]['category'],
            //     isCurrent: all_facilities[i]['facility_id'] === this.props.CurrentFacility
            // })

            chart3_data.push({
                facilityName,
                key: i.toString(),
                xField: all_facilities[i]['facility'],
                yField: all_facilities[i]['eui'] ? all_facilities[i]['eui'] : 0,
                type: all_facilities[i]['facility_category_name'],
                isCurrent: all_facilities[i]['facility_id'] === this.props.CurrentFacility
            })

        }

        chart1_data = chart1_data.sort((a, b) => a.xAxis - b.xAxis)
        chart2_data = chart2_data.sort((a, b) => a.xAxis - b.xAxis)
        chart3_data = chart3_data.sort((a, b) => b.yField - a.yField)

        // isCurrentIndex = chart3_data.findIndex(e => e.id === isCurrentId)

        // chart3_data = chart3_data

        this.setState({
            data: paginatedData,
            allFilteredData: all_facilities,
            chart1_data,
            chart2_data,
            chart3_data,
            colors_type,
            isLoading: false
        })
        return {
            data: paginatedData,
            success: true,
            total: totalCount
        }
    }

    // 生成筛选器选项（基于原始数据，不受筛选影响）
    generateFilterOptions = (data) => {

        let climate_zone_options = [], region_data = [], city_data = [], state_data = [], country_data = [], start_min_year = null, end_max_year = null;

        // 不再添加 "All" 选项，清空即表示全部
        for (let i = 0; i < data.length; i++) {
            if (data[i].climate_zone) {
                climate_zone_options.push({label: data[i].climate_zone, value: data[i].climate_zone});
            }
            // category_options 现在从接口加载，不再从数据中提取
            if (data[i].region) {
                region_data.push({label: data[i].region, value: data[i].region});
            }
            if (data[i].city) {
                city_data.push({label: data[i].city, value: data[i].city});
            }
            if (data[i].state) {
                state_data.push({label: data[i].state, value: data[i].state});
            }
            if (data[i].country) {
                country_data.push({label: data[i].country, value: data[i].country});
            }
            if (start_min_year) {
                start_min_year = Math.min(start_min_year, data[i].year)
            } else {
                start_min_year = data[i].year
            }
            if (end_max_year) {
                end_max_year = Math.max(end_max_year, data[i].year)
            } else {
                end_max_year = data[i].year
            }
        }

        this.setState({
            climate_zone_options: removeDuplicates(climate_zone_options),
            // category_options 不在这里更新，保留从接口加载的数据
            region_options: removeDuplicates(region_data),
            city_options: removeDuplicates(city_data),
            state_options: removeDuplicates(state_data),
            country_options: removeDuplicates(country_data),
            company_options: [
                {label: 'Current Company', value: 'CurrentCompany'},
                {label: 'Anonymous', value: 'Anonymous'}
            ],
            start_min_year: start_min_year,
            end_max_year: end_max_year
        })
    }

    // 保持 getData 方法以兼容表格回调，但不再使用传入的数据
    getData = (data) => {
        // 不再使用传入的数据生成筛选器选项
        // 筛选器选项已经在 handleFilter 中基于原始数据生成
    }

    setFilterDates = (dates) => {
        this.setState({
            filter_dates: dates
        })
    }

    handleChartSelect = (e) => {
        this.setState({
            selected_months: [e]
        })
        let id = _.get(this.state.data.filter(f => moment(f['service_month']).format('YY-MMM') === e)[0], 'id')
        this.setState({
            selected_id: id
        })
    }

    handleSelectFacilities = (e) => {

    }

    renderHeader = (e) => {
        return (
            <div className={'w-full lg:w-auto flex items-center my-10  px-3 flex-wrap'}>
                <div className={'inline-flex justify-center items-center w-10 h-10 mr-4 rounded'}>
                    <img src={dashboard}/>
                </div>
                <div className={''}>
                    <h2 className="text-lg font-bold">Comparing All Facilities</h2>
                    <p>As of {asOfDate()}</p>
                </div>
            </div>
        )
    }

    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    setFilters = (e) => {

        this.setState({
            filtered_start_year: e.year_range && e.year_range[0] ? moment(e.year_range[0]).year() : '',
            filtered_end_year: e.year_range && e.year_range[1] ? moment(e.year_range[1]).year() : '',
            filtered_region: e.region || [],
            filtered_city: e.city || [],
            filtered_state: e.state || [],
            filtered_country: e.country || [],
            filtered_climate_zone: e.climate_zone || [],
            filtered_category: e.category || [],
            filtered_company: e.company || ''
        }, function () {
            this.refresh(false)
        })
    }

    refresh = (needRequest) => {
        return this.tableRef?.current?.refresh(needRequest);
    };

    renderFilter = (isMobileDrawer = false) => {
        return <FacilityBenchmarkFilters
            start_min_year={this.state.start_min_year}
            end_max_year={this.state.end_max_year}
            climate_zone_options={this.state.climate_zone_options}
            category_options={this.state.category_options}
            region_options={this.state.region_options}
            city_options={this.state.city_options}
            state_options={this.state.state_options}
            country_options={this.state.country_options}
            company_options={this.state.company_options}
            handleFilter={this.setFilters}
            isMobileDrawer={isMobileDrawer}
        />
    }

    render() {
        const isH5 = this.props.isH5 === true;

        return (

            <FacilityBenchmarkStyles>
                <Spin spinning={this.state.isLoading}>

                    {/*{this.renderHeader()}*/}

                    {/*dashboard*/}
                    <Row className={'w-full mb-4'} gutter={[16, 16]}>
                        <Col xs={24} md={12} xl={12}>

                                <BubblePlot fillOpacity={0.5}
                                            opacity={0.65}
                                            data={this.state.chart1_data} title='EUI (kBtu/sqft-yr)'
                                            xLabel='Year' yLabel='EUI'
                                            colors={this.state.colors_type}
                                            showTip={true}
                                            />

                        </Col>
                        <Col xs={24} md={12} xl={12}>

                                <BubblePlot fillOpacity={0.5}
                                            opacity={0.65}
                                            xLabel='Year' yLabel='Costs ($/sqft-yr)'
                                            data={this.state.chart2_data} title='Energy Costs ($/sqft-yr)'
                                            colors={this.state.colors_type}
                                            showTip={true}
                                            />

                        </Col>
                        <Col xs={24} md={24} xl={24}>

                            <BarChart data={this.state.chart3_data}
                                      title='EUI (kBtu/sqft-yr)'
                                      fillOpacity={1}
                                      opacity={1}
                                      xLabel='Facility' yLabel='EUI'
                                      showTip={true}
                                      />
                        </Col>

                    </Row>

                    {/*table*/}
                    {/*<Collapse defaultActiveKey={['col0']} ghost>*/}
                    {/*    <Panel key={'col0'} header={<Divider/>}>*/}
                    <div id={'compact-form'}>


                        <FacilityBenchmarkTableContent
                            ref={this.tableRef}
                            columns={FacilityBenchmarkColumns(this.state.allFilteredData, this.props.RoleKey, this.handleDeleteBenchmark, this.state.facilityCategoryOptions)}
                            data={this.state.data}
                            columnProps={FacilityBenchmarkProps}
                            formFields={''}
                            formRelated={''}
                            postComment={''}
                            getRecord={this.getData}
                            createRecords={this.handleCreate}
                            deleteRecord={this.handleDelete}
                            bulkInsert={this.handleBulkInsert}
                            bulkDelete={this.handleBulkDelete}
                            handOnlineSave={this.handOnlineSave}
                            handleFilter={this.handleFilter}
                            renderFilter={isH5 ? undefined : this.renderFilter}
                            setFilters={this.setFilters}

                            isRowClickable={false}
                            selected_row={this.props.CurrentFacility}
                            relatedList={this.props.relatedList}
                            relatedId={this.props.relatedId}
                            relatedObject={this.props.relatedObject}
                            toolBarRender={true}
                            isChat={true}
                            isRelated={false}
                            isAttachments={false}
                            hide_imports={true}
                            hide_date={true}
                            hide_search={false}
                            isRowSelection={true}
                        />
                    </div>
                    {/*    </Panel>*/}
                    {/*</Collapse>*/}

                    <Row className={'w-full mt-5'}>
                        <Col xs={24} md={24} xl={24} className={' p-6 mb-4'}>
                            <GoogleMaps data={this.state.allFilteredData} height={'350px'}
                                        zoom={3.5}
                                isZoomEnabled={false}
                            />
                        </Col>
                    </Row>

                    {isH5 ? (
                        <ResponsiveModal
                            title="Filter"
                            open={this.props.filterDrawerOpen}
                            onCancel={this.props.onCloseFilterDrawer}
                            footer={null}
                            height="82vh"
                            bodyStyle={{ paddingBottom: 16 }}
                        >
                            {this.renderFilter(true)}
                        </ResponsiveModal>
                    ) : null}

                </Spin>
            </FacilityBenchmarkStyles>

        );
    }
}


const mapStateToProps = state => {
    const roleObject = state.Auth.role ?? {};
    const role = Object.keys(roleObject)[0] * 1;
    
    return {
        FacilityBenchmark: _.get(state.FacilityBenchmark, 'data'),
        Selected_Rows: _.get(state.EditableTable, 'selected_rows'),
        CurrentFacility: _.get(state.Facility, 'selected.Id'),
        CurrentCompany: _.get(state.Facility, 'selected.record.company_id'),
        RoleKey: role
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFacilityBenchmarkRequest: (e) => dispatch(actions.FacilityBenchmarkRequest(e)),
        setFacilityBenchmarkSuccess: (e) => dispatch(actions.FacilityBenchmarkSuccess(e)),
        SelectedRows: (ids) => dispatch(EditableTableActions.SelectedRows(ids))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FacilityBenchmark);
